import * as React from "react";
import { MainLayout, Sticky } from "wmk-layout";
import Header from "./Header";
import Footer from "./Footer";

/* Feed this to your header and/or footer once data is queried */
import { MenuData, HyperLink } from "wmk-menu";

const Layout = ({
  children
}: {
  children: React.ReactNode | React.ReactNode[];
}) => {
  return (
    <MainLayout
      Header={(
        // <Sticky>
        children?.props?.pageResources?.page?.path.includes("404") ? <Header is404/> : <Header />
        // </Sticky>
      )}
      Footer={children?.props?.pageResources?.page?.path.includes("404") ? <Footer is404/> : <Footer />}
      // Footer={() => <Footer />}
      >
      {children}
    </MainLayout>
  );
};

export default Layout;
